import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

export async function GetFetchSeccionesActivos() {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon/secciones/all?FIESTATUS="1"`
      : `/home/admon/secciones/all?FIESTATUS="1"`;
  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Realizar la solicitud Axios usando la instancia personalizada
  return axiosInstance(requestConfig);
}
